<template>
  <!-- <pre v-if="responseData">detailsUmurData={{ responseData }}</pre> -->
  <Background v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/AHLI MAJLIS PBT.png"
        alt="AHLI MAJLIS PBT"
        class="pbt-image"
      />

      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <div class="majlis-content">
        <div class="majlis-item">
          <img
            src="@/assets/jkt/male.png"
            alt="Male Image"
            class="majlis-image"
          />

          <div class="majlis-numbers">
            <p>{{ numberWithCommas(ahli.overallData.lelaki) }}</p>
            <span
              >{{
                calculatePercentage(
                  ahli.overallData.lelaki,
                  ahli.overallData.wanita,
                  ahli.overallData.keseluruhan
                ).malePercentage
              }}%</span
            >
          </div>
        </div>
        <div class="majlis-item">
          <img
            src="@/assets/jkt/female.png"
            alt="Female Image"
            class="majlis-image"
          />
          <div class="majlis-numbers">
            <p>{{ numberWithCommas(ahli.overallData.wanita) }}</p>
            <span
              >{{
                calculatePercentage(
                  ahli.overallData.lelaki,
                  ahli.overallData.wanita,
                  ahli.overallData.keseluruhan
                ).femalePercentage
              }}%</span
            >
          </div>
        </div>
      </div>

      <h2>JUMLAH BILANGAN AHLI MAJLIS PBT WANITA BAGI SETIAP NEGERI</h2>
      <div class="chart-wrapper">
        <Female :data="FemaleData" />
        <Update />
      </div>

      <h2>JUMLAH BILANGAN AHLI MAJLIS PBT LELAKI BAGI SETIAP NEGERI</h2>
      <div class="chart-wrapper">
        <Male :data="MaleData" />
        <Update />
      </div>
    </div>

    <div class="content-wrapper">
      <h2>JUMLAH BILANGAN AHLI MAJLIS PBT BERSTATUS OKU</h2>
      <div class="image-grid">
        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/kelantan1.png" alt="Kelantan" />
          <div class="text-overlay">
            <p class="state-name">KELANTAN</p>
            <p class="state-number">
              {{ getStatusOku("Kelantan") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/kedah1.png" alt="Kedah" />
          <div class="text-overlay">
            <p class="state-name">KEDAH</p>
            <p class="state-number">
              {{ getStatusOku("Kedah") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/johor2.png" alt="" />
          <div class="text-overlay">
            <p class="state-name">JOHOR</p>
            <p class="state-number">
              {{ getStatusOku("Johor") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/sarawak.png" alt="Penang" />
          <div class="text-overlay">
            <p class="state-name">SARAWAK</p>
            <p class="state-number">
              {{ getStatusOku("Sarawak") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/selangor.png" alt="" />
          <div class="text-overlay">
            <p class="state-name">SELANGOR</p>
            <p class="state-number">
              {{ getStatusOku("selangor") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/wilayah.png" alt="wilayah" />
          <div class="text-overlay">
            <p class="state-name">KUALA LUMPUR</p>
            <p class="state-number">
              {{ getStatusOku("Kuala Lumpur") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/putra.png" alt="putra" />
          <div class="text-overlay">
            <p class="state-name">PUTRAJAYA</p>
            <p class="state-number">
              {{ getStatusOku("Putrajaya") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/penang.png" alt="penang" />
          <div class="text-overlay">
            <p class="state-name">PULAU PINANG</p>
            <p class="state-number">
              {{ getStatusOku("Pulau Pinang") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/perlis.png" alt="" />
          <div class="text-overlay">
            <p class="state-name">PERLIS</p>
            <p class="state-number">
              {{ getStatusOku("perlis") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/sabah.png" alt="Sabah" />
          <div class="text-overlay">
            <p class="state-name">SABAH</p>
            <p class="state-number">
              {{ getStatusOku("Sabah") }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/pahang1.png" alt="pahang" />
          <div class="text-overlay">
            <p class="state-name">PAHANG</p>
            <p class="state-number">
              {{ getStatusOku("Pahang") }}
            </p>
          </div>
        </div>
        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/melaka.png" alt="Melaka" />
          <div class="text-overlay">
            <p class="state-name">MELAKA</p>
            <p class="state-number">
              {{ getStatusOku("Melaka") }}
            </p>
          </div>
        </div>
        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/terengganu.png"
            alt="terengganu"
          />
          <div class="text-overlay">
            <p class="state-name">TERENGGANU</p>
            <p class="state-number">
              {{ getStatusOku("Terengganu") }}
            </p>
          </div>
        </div>
        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/sembilan.png" alt="sembilan" />
          <div class="text-overlay">
            <p class="state-name">NEGERI SEMBILAN</p>
            <p class="state-number">
              {{ getStatusOku("Negeri Sembilan") }}
            </p>
          </div>
        </div>
        <div class="image-container">
          <img src="@/assets/jkt/AhliMajlisPBT/perak1.png" alt="perak" />
          <div class="text-overlay">
            <p class="state-name">PERAK</p>
            <p class="state-number">
              {{ getStatusOku("Perak") }}
            </p>
          </div>
        </div>
      </div>
      <Update />
    </div>

    <div class="content-wrapper">
      <h2>JUMLAH BILANGAN AHLI MAJLIS PBT MENGIKUT UMUR</h2>
      <div class="umur">
        <div class="umur-container">
          <img src="@/assets/jkt/AhliMajlisPBT/first.png" alt="First Image" />
          <div class="text-overlay-center">
            <h3>26 KEBAWAH</h3>
            <p>
              <span class="value"
                >{{ detailsUmurData[0]?.bawah_26 ?? 0 }} Orang</span
              >
            </p>
          </div>
        </div>

        <div class="umur-container">
          <img src="@/assets/jkt/AhliMajlisPBT/second.png" alt="Second Image" />
          <div class="text-overlay-right">
            <h3>26 - 40</h3>
            <p>
              <span class="value"
                >{{ detailsUmurData[0]?.umur26_40 ?? 0 }} Orang</span
              >
            </p>
          </div>
        </div>

        <div class="umur-container">
          <img src="@/assets/jkt/AhliMajlisPBT/third.png" alt="Third Image" />
          <div class="text-overlay-center">
            <h3>41 - 59</h3>
            <p>
              <span class="value"
                >{{ detailsUmurData[0]?.umur41_59 ?? 0 }} Orang</span
              >
            </p>
          </div>
        </div>

        <div class="umur-container">
          <img src="@/assets/jkt/AhliMajlisPBT/foor.png" alt="Fourth Image" />
          <div class="text-overlay-right">
            <h3>ATAS 60</h3>
            <p>
              <span class="value"
                >{{ detailsUmurData[0]?.atas_60 ?? 0 }} Orang</span
              >
            </p>
          </div>
        </div>
      </div>
      <Update />
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Menu from "@/components/menu-items/utama-menu.vue";
import { useHttpService } from "@/httpService";
import moment from "moment";
import { onMounted, ref } from "vue";
import * as am5 from "@amcharts/amcharts5";

//added by abdullah
definePage({
  alias: "/pages/pages/inspektorat/ahli-pbt",
  meta: {
    layout: "blank",
    public: true,
  },
});

const {
  loading,
  error,
  httpDelete,
  httpPostPut,
  httpGet,
  httpPost,
  numberWithCommas,
  formatToMillion,
  calculatePercentage,
} = useHttpService();

const ahli = ref({
  selectedYear: moment().format("YYYY"),
  overallData: {
    keseluruhan: 0,
    lelaki: 0,
    wanita: 0,
  },
});

const responseData = ref(null);

const councils = ref();
const statesData = ref();
const overallData = ref();
const detailsUmurData = ref();
const date = ref();
const years = ref();
const year = ref();
const MaleData = ref([]);
const FemaleData = ref([]);

function getStatusOku(stateName) {
  const stateData = statesData.value.find((item) => item.state === stateName);

  return stateData ? stateData.status_oku : "0";
}

async function loadDataFromApiAhliPbt() {
  try {
    const response = await httpGet("inspektorat/ahli-majlis-pbt");

    responseData.value = response;
    statesData.value = response.data.negeri;
    overallData.value = response.data.keseluruhan;
    detailsUmurData.value = response.data.umur;

    date.value = response.data;
    years.value = response.years;
    year.value = response.data_information.year;

    ahli.value.councilList = councils.value;
    ahli.value.years = years;
    ahli.value.selectedYear = year;

    ahli.value.overallData = {
      keseluruhan: overallData.value.jumlah_keseluruhan_ahli_majlis,
      lelaki: overallData.value.jumlah_keseluruhan_ahli_majlis_lelaki,
      wanita: overallData.value.jumlah_keseluruhan_ahli_majlis_wanita,
    };

    if (date.value != null) {
      ahli.value.ahliMajlisDate = moment(date).toDate();
    }

    const male = response.data.negeri;

    const data = [
      {
        name: "Johor",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/flag-of-johor_ver_1.png",
        },
        color: am5.color("#06287f"),
      },
      {
        name: "Kedah",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/kedah-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#064401"),
      },
      {
        name: "Kelantan",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/kelantan-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#a80000"),
      },
      {
        name: "Negeri Sembilan",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/negeri-sembilan-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#ec4747"),
      },
      {
        name: "Pahang",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/screenshot-2023-06-26-at-5.19.54-pm_ver_1.png",
        },
        color: am5.color("#457ae0"),
      },
      {
        name: "Pulau Pinang",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/flag-of-penang_ver_1.png",
        },
        color: am5.color("#9747ff"),
      },
      {
        name: "Perak",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/screenshot-2023-06-26-at-5.21.54-pm_ver_1.png",
        },
        color: am5.color("#fab400"),
      },
      {
        name: "Selangor",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/selangor-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#faf000"),
      },
      {
        name: "Terengganu",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/screenshot-2023-06-26-at-5.51.42-pm_ver_1.png",
        },
        color: am5.color("#330471"),
      },
      {
        name: "Sarawak",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/sarawak-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#ff9f47"),
      },
    ];

    MaleData.value = data.map((item) => {
      const stateData = male.find((s) => s.state === item.name);

      const updatedData = {
        ...item,
        steps: stateData ? parseInt(stateData.lelaki) : 0,
      };

      console.log("Updated Male Data:", updatedData);

      return updatedData;
    });

    FemaleData.value = data.map((item) => {
      const stateData = male.find((s) => s.state === item.name);

      const updatedData = {
        ...item,
        steps: stateData ? parseInt(stateData.wanita) : 0,
      };

      console.log("Updated Female Data:", updatedData);

      return updatedData;
    });
  } catch (err) {
    console.error("loadDataFromApiAhliPbt failed:", err);
  }
}
onMounted(() => {
  loadDataFromApiAhliPbt();
});
</script>

<style scoped>
.content-wrapper {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
  padding-inline: 40px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: start;
}

.majlis-content {
  display: flex;
  justify-content: center;
  gap: 50px;
  inline-size: 100%;
  margin-block-end: 10px;
  max-inline-size: 700px;
}

.majlis-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-block: 0;
  margin-inline: 40px;
}

.majlis-image {
  inline-size: 100%;
  margin-block-end: 20px;
  max-inline-size: 250px;
}

.majlis-numbers {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border-radius: 10px;
  color: rgb(21, 0, 105);
  font-weight: bold;
  text-align: center;
}

.majlis-numbers p {
  margin: 0;
  font-size: 2.5rem;
}

.majlis-numbers span {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  margin-block-start: 3px;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1200px;
}

/* Image Grid */
.image-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(5, 1fr);
  inline-size: 100%;
  max-inline-size: 1200px;
}

.text-overlay {
  position: absolute;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  inline-size: 100%;
  inset-block-end: 0;
  padding-block: 20px;
  padding-inline: 0;
  text-align: center;
}

.state-name {
  color: #150069;
  font-size: 20px;
  font-weight: 600;
  margin-block-end: 0; /* Adds spacing between name and number */
}

.state-number {
  position: relative;
  color: #a80000;
  font-size: 46px;
  font-weight: 600;
  inset-inline-end: -20px; /* Adjust ahli value to move the number slightly left */
  margin-block: -5px 10px; /* Adds spacing above the number */
  padding-inline-end: 70px; /* Decrease the padding to bring it closer to the center */
  text-align: end; /* Keeps the text aligned to the right */
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 10%);
  inline-size: 100%;
  padding-block-start: 125%;
}

.image-container img {
  position: absolute;
  block-size: 100%;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  object-fit: cover;
}

.age-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  inline-size: 100%;
  max-inline-size: 1200px;
}

.age-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 900px;
}

.people-image {
  inline-size: 40%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 500px;
}

.oku-text-box {
  position: relative;
  inline-size: 250px;
  margin-block-end: 20px;
}

.oku-text-box img {
  border-radius: 10px;
  block-size: auto;
  inline-size: 100%;
}

.text {
  position: absolute;
  z-index: 1;
  color: #150069;
  inline-size: 100%;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}

h3 {
  color: #150069;
  font-size: 1.8rem;
}

.value {
  color: #a80000;
  font-size: 2rem;
  font-weight: bold;
}

.umur {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.umur-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: auto;
  max-inline-size: 900px;
}

.text-overlay-center {
  position: absolute;
  top: 50%;
  left: 25%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #150069;
  font-family: Arial, sans-serif;
  padding: 10px 20px;
  border-radius: 10px;
}

.text-overlay-right {
  position: absolute;
  top: 50%;
  right: 5%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #150069;
  font-family: Arial, sans-serif;
  padding: 10px 20px;
  border-radius: 10px;
}

.text-overlay-center,.text-overlay-right h3 {
  font-size: 30px;
  font-weight: 600;
  margin: 0;
}

.text-overlay-center,.text-overlay-right  p {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
  margin: 5px 0 0;
}

.value {
  color: #d60000; /* red color like in your sample */
}
.text {
  color: #150069;
}

/* ----- Responsive Styles ----- */
@media (max-width: 1024px) {
  h2 {
    font-size: 1.4rem;
    text-align: center;
  }

  .umur-container {
    max-inline-size: 700px;
  }

  .text-overlay-center h3 {
    font-size: 26px;
  }

  .text-overlay-center p {
    font-size: 24px;
  }
}

@media (max-width: 770px) {
  .umur {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .umur-container {
    max-inline-size: 90%;
  }

  .text-overlay-center h3 {
    font-size: 24px;
  }

  .text-overlay-center p {
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .umur {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }

  .umur-container {
    max-inline-size: 100%;
    margin: 0 auto;
  }

  .text-overlay-center {
    padding: 5px 10px;
  }

  .text-overlay-center h3 {
    font-size: 20px;
  }

  .text-overlay-center p {
    font-size: 18px;
  }
}
</style>
